/* eslint-disable jsx-a11y/anchor-is-valid */
import { Link } from 'react-router-dom'
import * as S from './styles'
import * as HeaderStyles from '../Header/styles'
import * as auth from '../../api/auth/auth'
import mock from './mock/profile'
import { isPromotor } from '../MenuProfile/sideMenuUtils'
import { useDispatch, useSelector } from 'react-redux'
import { useState } from 'react'
import { useEffect } from 'react'
import { fetchUser } from '../../pages/MeuPerfil/fetch'
import { setUserInfo } from '../../store/ducks/user'

function ProfileModal({ active }) {
  const logout = () => {
    auth.logout()
  }
  const store = useSelector((reduxState) => reduxState)
  const dispatch = useDispatch()

  const [userData, setUserData] = useState('')

  // useEffect(() => {
  //   fetchUser(setUserData)
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [])

  // useEffect(() => {
  //   if (store.user.info.id === undefined && userData !== '') {
  //     dispatch(setUserInfo(userData))
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [store.user.info, userData])
  return (
    <S.Wrapper active={active}>
      <HeaderStyles.HeaderModalBox className="header-modal-box">
        <S.ModalList className="header-modal-profile-list">
          {/* {mock.links.map(({ name, link }) => (
            <S.ModalListItem key={name} className="header-modal-profile-item">
              <Link to={link}>{name}</Link>
            </S.ModalListItem>
          ))} */}

          {/*
          <S.ModalListItem className="header-modal-profile-item">
            <Link to="#" onClick={() => logout()}>
              Sair
            </Link>
          </S.ModalListItem> */}

          <S.ModalListItem className="perfil-menu-item">
            <Link exact to="/meu-perfil">
              Dados de Cadastro
            </Link>
          </S.ModalListItem>
          <S.ModalListItem className="perfil-menu-item">
            <Link to="/meus-pedidos">Meus Pedidos</Link>
          </S.ModalListItem>
          <S.ModalListItem className="perfil-menu-item">
            <a
              href={`${process.env.REACT_APP_URL_MAIN}/meuperfil/minhalista`}
              className="perfil-menu-item-link"
            >
              Minhas Listas
            </a>
          </S.ModalListItem>
          <S.ModalListItem className="perfil-menu-item">
            <Link exact to="/meus-enderecos">
              Meus Endereços
            </Link>
          </S.ModalListItem>
          <S.ModalListItem className="perfil-menu-item">
            <Link exact to="/meus-cartoes">
              Meus Cartões
            </Link>
          </S.ModalListItem>
          {
            <S.ModalListItem className="perfil-menu-item">
              <Link exact to="/gimplus" className="perfil-menu-item-link">
                Gimplus
              </Link>
            </S.ModalListItem>
          }
          <S.ModalListItem className="perfil-menu-item">
            <Link exact to="/negociacoes" className="perfil-menu-item-link">
              Negociações
            </Link>
          </S.ModalListItem>
          <S.ModalListItem className="perfil-menu-item">
            <Link exact to="/cotacoes" className="perfil-menu-item-link">
              Cotações
            </Link>
          </S.ModalListItem>

          {auth.isPF() &&
          isPromotor(store.user.info.codigoPromotor) === true ? (
            <S.ModalListItem className="perfil-menu-item">
              <Link
                exact
                to="/vendas-promovidas"
                className="perfil-menu-item-link"
              >
                Vendas Promovidas
              </Link>
            </S.ModalListItem>
          ) : null}

          {!auth.isPF() && (
            <S.ModalListItem className="perfil-menu-item">
              <a
                href={`${process.env.REACT_APP_URL_MAIN}/boleto/lista`}
                className="perfil-menu-item-link"
              >
                2ª via de Boleto
              </a>
            </S.ModalListItem>
          )}

          {/* <S.ModalListItem className="perfil-menu-item">
              <Link

                exact
                to="/alterar-senha"
                className="perfil-menu-item-link"
              >
                Alterar Senha
              </Link>
            </S.ModalListItem> */}
          <hr />

          <S.ModalListItem className="perfil-menu-item">
            <a
              href={process.env.REACT_APP_URL_MAIN}
              className="perfil-menu-item-link"
            >
              Sair
            </a>
            {/* <Link
                exact
                to="#"
                className="perfil-menu-item-link"
                onClick={() =>
                  (window.location.href = `${process.env.REACT_APP_URL_MAIN}/MarketPlaceCliente/logout`)
                }
              >
                Sair
              </Link> */}
          </S.ModalListItem>
        </S.ModalList>
      </HeaderStyles.HeaderModalBox>
    </S.Wrapper>
  )
}

export default ProfileModal
